import FileViewerContainer from 'pages/fileViewer/FileViewerContainer';
import { Dialog, DialogContent, Slide } from '@mui/material';
import * as React from 'react';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import MDTypography from 'components/MDTypography';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';
import { getFileViewerTitle } from 'utils/entityUtils';
import { Preview } from '@mui/icons-material';
import Toolbar from '@mui/material/Toolbar';
import MDButton from 'components/MDButton';
import { updateModalOpen } from 'slice/fileViewerSlice';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

/**
 * FileViewerModal is a component that presents a file viewer in a full screen modal dialog.
 * It uses a slide-up transition when opening.
 *
 * @component
 * @example
 * <FileViewerModal />
 *
 * @returns {JSX.Element} The FileViewerModal component, which encapsulates a FileViewerContainer component
 * in a full-screen modal dialog with slide-up transition.
 */
function FileViewerModal() {
  const { formatMessage: msg } = useIntl();
  const modalOpen = useSelector((state) => state.fileViewer.modalOpen);
  const dispatch = useDispatch();
  const previousHash = window.location.hash;
  const [modalTitle, setModalTitle] = useState('');

  const handleEntityUpdated = (entity) => {
    setModalTitle(getFileViewerTitle(entity, msg({ id: 'page.fileViewer' }), msg));
  };
  const handleDialogClose = () => {
    dispatch(updateModalOpen(false));
  };

  useEffect(() => {
    const handleHashChange = () => {
      dispatch(updateModalOpen(false));
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [dispatch, previousHash]);

  return (
    <Dialog
      fullScreen
      open={modalOpen}
      onClose={handleDialogClose}
      TransitionComponent={Transition}
    >
      <Toolbar variant="dense" disableGutters sx={{ p: 1 }}>
        <Preview fontSize="large" edge="start" color="inherit" />
        <MDTypography variant="h3" sx={{ flex: 1, verticalAlign: 'middle' }}>
          {modalTitle}
        </MDTypography>
        <Tooltip edge="start" title={msg({ id: 'action.close' })}>
          <MDButton
            variant="gradient"
            color="primary"
            edge="end"
            sx={{ minWidth: '40px', p: 0 }}
            aria-label={msg({ id: 'action.close' })}
            onClick={handleDialogClose}
          >
            <CloseIcon sx={{ width: '28px', height: '28px' }} color="white" />
          </MDButton>
        </Tooltip>
      </Toolbar>

      <DialogContent dividers sx={{ p: 0 }}>
        <FileViewerContainer onEntityUpdated={handleEntityUpdated} />
      </DialogContent>
    </Dialog>
  );
}

export default FileViewerModal;
